import React, { useState } from "react";
import { ReceiptStructuredResult } from "../lib/api";

type FormValues = Partial<ReceiptStructuredResult> & { userNotes?: string };

type Props = {
  initial: FormValues;
  saving: boolean;
  onSave: (values: FormValues) => void;
  onCancel: () => void;
};

type Field = { key: keyof FormValues; label: string; placeholder?: string };

const FIELDS: Field[] = [
  { key: "merchantName", label: "店舗名" },
  { key: "receiptDate", label: "日付", placeholder: "YYYY-MM-DD" },
  { key: "totalAmount", label: "合計金額" },
  { key: "currency", label: "通貨", placeholder: "JPY" },
  { key: "taxAmount", label: "税額" },
  { key: "paymentMethod", label: "支払方法" },
  { key: "invoiceNumber", label: "インボイス番号" },
  { key: "accountCategory", label: "勘定科目" },
  { key: "summary", label: "概要" },
  { key: "userNotes", label: "メモ" },
];

export function ReceiptEditForm({ initial, saving, onSave, onCancel }: Props) {
  const [values, setValues] = useState<FormValues>(initial);

  const handleChange = (key: keyof FormValues, value: string) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(values);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {FIELDS.map(({ key, label, placeholder }) => (
        <div key={key}>
          <label className="mb-1 block text-xs font-bold text-[#7C5A4E]">{label}</label>
          {key === "summary" || key === "userNotes" ? (
            <textarea
              className="w-full rounded-xl border border-[#E8D5C8] bg-white/80 px-3 py-2 text-sm text-[#4A3E39] focus:outline-none focus:ring-2 focus:ring-[#A67C52]/40"
              rows={3}
              value={values[key] ?? ""}
              placeholder={placeholder}
              onChange={(e) => handleChange(key, e.target.value)}
            />
          ) : (
            <input
              type="text"
              className="w-full rounded-xl border border-[#E8D5C8] bg-white/80 px-3 py-2 text-sm text-[#4A3E39] focus:outline-none focus:ring-2 focus:ring-[#A67C52]/40"
              value={values[key] ?? ""}
              placeholder={placeholder}
              onChange={(e) => handleChange(key, e.target.value)}
            />
          )}
        </div>
      ))}

      <div className="flex flex-col gap-2 pt-2">
        <button
          type="submit"
          className="w-full rounded-full bg-[#A67C52] py-2.5 text-sm font-bold text-white hover:bg-[#7C5A4E] disabled:opacity-60"
          disabled={saving}
        >
          {saving ? "保存中…" : "保存する"}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="w-full rounded-full border border-[#A67C52] py-2.5 text-sm font-bold text-[#A67C52] hover:bg-[#F5EDE8] disabled:opacity-60"
          disabled={saving}
        >
          キャンセル
        </button>
      </div>
    </form>
  );
}
